import { styles, StylesVariants } from './CircularSchema.css'
import { AppText } from '../../AppText'

interface CircularSchemaProps extends StylesVariants {
	graph: {
		circularSchema: string
		circularSchemaName: string
		badge: string
	}
	moreElements: boolean
}

export const CircularSchema: React.FC<CircularSchemaProps> = ({ graph, moreElements }) => {
	const { wrapper, graphStyle, text, content, badgeStyle } = styles()

	return (
		<div className={wrapper({ moreElements })}>
			<span
				className={badgeStyle({ moreElements })}
				dangerouslySetInnerHTML={{ __html: graph.badge }}
			/>
			<div className={content({ moreElements })}>
				<span className={graphStyle()} dangerouslySetInnerHTML={{ __html: graph.circularSchema }} />
				<AppText
					as="p"
					family="condensed"
					color="white"
					textTransform="uppercase"
					className={text({ moreElements })}
				>
					{graph.circularSchemaName}
				</AppText>
			</div>
		</div>
	)
}
